var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHightlighterButton = function SvgHightlighterButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 119"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hightlighter_button_svg__a",
    width: 53,
    height: 53,
    x: 129,
    y: 2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hightlighter_button_svg__b",
    width: 53,
    height: 53,
    x: 103,
    y: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hightlighter_button_svg__c",
    width: 53,
    height: 53,
    x: 0,
    y: 2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58107"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58102",
    transform: "translate(-386 -2033.584)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8a89f",
    d: "M420 2097.584h67v51h-67z",
    "data-name": "Rectangle 33335"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#b27594",
    "data-name": "Ellipse 11287",
    transform: "translate(436 2105.584)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#744a60",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 25,
    fontWeight: 500,
    transform: "translate(454 2131.584)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9,
    y: 0
  }, "D"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58103",
    transform: "translate(-365 -2097.584)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b7f3b4",
    d: "M420 2097.584h67v51h-67z",
    "data-name": "Rectangle 33335"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#6cc8a5",
    "data-name": "Ellipse 11287",
    transform: "translate(436 2105.584)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#488e74",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 25,
    fontWeight: 500,
    transform: "translate(454 2131.584)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7,
    y: 0
  }, "B"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58104"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hightlighter_button_svg__a)",
    transform: "translate(0 -.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#8ea9da",
    "data-name": "Ellipse 11288",
    transform: "translate(138 8)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#5a7cac",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 25,
    fontWeight: 500,
    transform: "translate(156 34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9,
    y: 0
  }, "C"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58105"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hightlighter_button_svg__b)",
    transform: "translate(0 -.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#8ea9da",
    "data-name": "Ellipse 11288",
    transform: "translate(112 72)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#5a7cac",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 25,
    fontWeight: 500,
    transform: "translate(130 98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58106"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hightlighter_button_svg__c)",
    transform: "translate(0 -.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#8ea9da",
    "data-name": "Ellipse 11288",
    transform: "translate(9 8)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#5a7cac",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 25,
    fontWeight: 500,
    transform: "translate(27 34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "A"))))));
};
export default SvgHightlighterButton;